import React, { useState } from 'react';
import PropTypes from 'prop-types';
import template from 'lodash/template';
import phrasesType from '../../proptypes/phrases';

import PageSection from '../../design-system/PageSection';
import Container from '../../design-system/Containers';
import Modal from '../Modal';
import { HeadingPara } from '../../design-system/Headings';
import { Form, Field, Submit } from '../../design-system/Forms';
import formType from '../../proptypes/forms';
import Paragraph from '../../design-system/Paragraph';
import { ResponsiveImage } from '../../design-system/Images';
import { ssColorCyan } from '../../constants/style-constants';

const ModalGradient = () => <div className="ss_modal-background" />;

export default function ProfileInvitationModal({
  form,
  visible,
  onCloseClick,
  inputFieldValues,
  phrases,
}) {
  const [formSuccess, setFormSuccess] = useState();

  return (
    <Modal show={visible} onClose={onCloseClick} limitWidth>
      <section className="ss_modal">
        <PageSection container={false}>
          <ModalGradient />
          <div className="ss_modal_content">
            <Container center myLg>
              {formSuccess ? (
                <>
                  <div
                    style={{
                      margin: '30px',
                      position: 'relative',
                      width: '50px',
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: `${ssColorCyan}`,
                        filter: 'blur(40px)',
                        height: '100%',
                        left: '0',
                        position: 'absolute',
                        right: '0',
                        top: '0',
                        width: '100%',
                      }}
                    />
                    <div
                      style={{
                        position: 'relative',
                      }}
                    >
                      <ResponsiveImage
                        alt=""
                        src="//images.ctfassets.net/gtqjh9j40j4m/38otjbEbmjqQtXMDYnOUNh/0f3681893b194a72d24dac80cbf7df6b/tick.svg"
                      />
                    </div>
                  </div>
                  <HeadingPara el="h2" py0 my0>
                    {phrases.success}
                  </HeadingPara>
                </>
              ) : (
                <>
                  <HeadingPara el="h2" py0 my0 pxSm>
                    {template(phrases.title)({
                      full_name: inputFieldValues?.fullName,
                    })}
                  </HeadingPara>
                  <Paragraph>{phrases.instruction}</Paragraph>
                  <Form
                    {...form}
                    inline
                    onSuccess={() => {
                      setFormSuccess(true);
                    }}
                    className="ss_w--100 ss_w--100 ss_px--md"
                  >
                    <Field
                      type="hidden"
                      name="profile_id"
                      value={inputFieldValues?.profileId}
                    />
                    <Field
                      required
                      label="Email"
                      name="email"
                      type="email"
                      defaultValue={inputFieldValues?.email}
                      className="ss_text-align--left"
                    />
                    <Submit>{phrases.buttonLabel}</Submit>
                  </Form>
                </>
              )}
            </Container>
          </div>
        </PageSection>
      </section>
    </Modal>
  );
}

ProfileInvitationModal.defaultProps = {
  inputFieldValues: {},
};

ProfileInvitationModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  form: formType.isRequired,
  inputFieldValues: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string])),
  phrases: phrasesType.isRequired,
};
